import { render } from "./AdminSignupParticipation.vue?vue&type=template&id=5856abf2"
import script from "./AdminSignupParticipation.vue?vue&type=script&lang=js"
export * from "./AdminSignupParticipation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__